/* Paid engraving is a separate Shopify line, never a surcharge stored in text. */
(() => {
  'use strict';
  if (window.stEngravingLoaded) return;
  window.stEngravingLoaded = true;
  const base = window.Shopify?.routes?.root || '/';
  const serviceHandle = 'company-name-logo-laser-engraving';
  const $ = (root, selector) => root.querySelector(selector);
  const isStandalone = root => root.dataset.standalone === 'true';
  const selection = root => $(root, '[data-eng-option]').selectedOptions[0];
  // Only a valid package (available, exact expected price, compatible with the model) counts.
  const selected = root => Boolean(window.stEngravingPackages?.selected(root));
  const fmt = (root, cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: root.dataset.currency || window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
  function syncStandaloneId(root) {
    if (!isStandalone(root) || !selected(root)) return;
    const id = $(root.closest('form'), '[name="id"]');
    const value = selection(root).value;
    if (id && id.value !== value) {
      if (id.tagName === 'SELECT' && ![...id.options].some(o => o.value === value)) id.add(new Option(value, value));
      id.value = value;
      id.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }
  const pinSelection = root => $(root, '[data-pin-option]');
  const pinSelected = root => Boolean(!isStandalone(root) && pinSelection(root)?.checked);
  const configured = root => selected(root) || pinSelected(root);
  const headingObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('st-eng__head--reveal');
      headingObserver.unobserve(entry.target);
    });
  }, {threshold: 0.5}) : null;
  const message = (root, text) => {
    const el = $(root, '[data-eng-error]');
    el.textContent = text;
    el.hidden = !text;
    root.querySelectorAll('[data-addon-error]').forEach(error => { error.textContent = ''; error.hidden = true; });
    if (text) {
      const kind = selected(root) || isStandalone(root) || !pinSelected(root) ? 'engraving' : 'pins';
      window.stAddonModals?.open(root, kind);
      const body = root.querySelector(`[data-st-addon-dialog="${kind}"] .st-addon-modal__body`);
      let alert = body?.querySelector('[data-addon-error]');
      if (body && !alert) {
        alert = document.createElement('p');
        alert.dataset.addonError = '';
        alert.className = 'st-eng__error';
        alert.setAttribute('role', 'alert');
        body.prepend(alert);
      }
      if (alert) { alert.textContent = text; alert.hidden = false; }
      (alert || el).scrollIntoView({block: 'center', behavior: 'smooth'});
    }
  };
  function refresh(root) {
    const form = root.closest('form');
    if (!form) return;
    window.stEngravingLocations?.sync(root);
    const option = selection(root);
    window.stAddonModals?.sync(root);
    const active = selected(root);
    const logo = active && option?.dataset.kind === 'logo';
    $(root, '[data-eng-fields]').hidden = !active;
    $(root, '[data-eng-company-wrap]').hidden = logo;
    $(root, '[data-eng-logo-wrap]').hidden = !logo;
    form.classList.toggle('st-engraving-selected', configured(root));
    const qty = Math.max(1, Number($(form, '[name="quantity"]')?.value) || 1);
    // Always the actual chosen Shopify variant price (Liquid verified it equals the package price).
    const cents = active ? Number(option.dataset.price || 0) : 0;
    const amount = fmt(root, qty * cents);
    const pkg = active ? window.stEngravingPackages.selected(root) : null;
    $(root, '[data-eng-total]').textContent = active
      ? `${amount} engraving total for ${qty} item${qty === 1 ? '' : 's'} (${pkg.name}, ${pkg.total} mark${pkg.total === 1 ? '' : 's'} per tool). ${isStandalone(root) ? 'Tool sold separately.' : 'Added as a separate paid accessory.'}`
      : '';
    const foot = $(root, '[data-eng-foot-total]');
    if (foot) {
      foot.dataset.state = active ? 'on' : 'off';
      foot.innerHTML = '';
      const a = document.createElement('span'), b = document.createElement('strong');
      a.className = 'st-eng__foot-label'; b.className = 'st-eng__foot-amount';
      if (active) {
        a.textContent = `${pkg.kind === 'logo' ? 'Logo' : 'Text'} \u00b7 ${pkg.name} \u00b7 ${fmt(root, cents)} \u00d7 ${qty}`;
        b.textContent = amount;
      } else {
        a.textContent = isStandalone(root) ? 'Choose a package to continue' : 'No engraving selected';
        b.textContent = isStandalone(root) ? '' : fmt(root, 0);
      }
      foot.append(a, b);
    }
    const pinTotal = $(root, '[data-pin-total]');
    if (pinTotal) {
      const pinAmount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: root.dataset.currency || window.Shopify?.currency?.active || 'USD'
      }).format(qty * Number(pinSelection(root).dataset.price) / 100);
      pinTotal.textContent = pinSelected(root) ? `${pinAmount} pin upgrade total for ${qty} set${qty === 1 ? '' : 's'}. Added as a separate paid product.` : '';
    }
    // Sticky forms must not bypass the configured main product form.
    if (!isStandalone(root)) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(other => {
        if (other === form || $(other, '[data-st-engraving]')) return;
        if ($(other, '[name="product-id"]')?.value === $(form, '[name="product-id"]')?.value) {
          other.classList.toggle('st-engraving-selected', configured(root));
        }
      });
    }
  }
  function initialize() {
    document.querySelectorAll('[data-st-engraving]').forEach(root => {
      if (root.dataset.ready) return;
      const form = root.closest('form');
      if (!form) return;
      root.dataset.ready = 'true';
      const heading = $(root, '.st-eng__head');
      if (heading) headingObserver?.observe(heading);
      form.classList.add('st-engraving-ready');
      window.stEngravingPreview?.init(root);
      root.addEventListener('change', event => {
        message(root, '');
        // Re-validate package against model before anything reads the selection.
        window.stEngravingLocations?.sync(root);
        if (event.target.matches('[data-eng-option],[data-eng-placement],[data-eng-sheave]')) {
          window.stAddonUsage?.track(root, selected(root) ? 'addon_selected' : 'addon_removed', {addon: 'engraving'}, true);
        }
        if (event.target.matches('[data-pin-option]')) {
          window.stAddonUsage?.track(root, pinSelected(root) ? 'addon_selected' : 'addon_removed', {addon: 'pins'}, true);
        }
        syncStandaloneId(root);
        refresh(root);
      });
      form.addEventListener('change', event => {
        if (isStandalone(root) && event.target.name === 'id') {
          const match = [...$(root, '[data-eng-option]').options].find(o => o.value === event.target.value && window.stEngravingPackages?.usable(root, o));
          if (match) match.selected = true;
        }
        refresh(root);
      });
      form.addEventListener('input', () => refresh(root));
      form.addEventListener('click', () => setTimeout(() => refresh(root), 40));
      if (isStandalone(root)) {
        const id = $(form, '[name="id"]');
        const match = id && [...$(root, '[data-eng-option]').options].find(o => o.value === id.value && window.stEngravingPackages?.usable(root, o));
        if (match) match.selected = true;
      }
      window.stEngravingLocations?.sync(root);
      syncStandaloneId(root);
      refresh(root);
    });
  }
  async function validate(root) {
    if (!selected(root)) throw Error('Choose an available engraving package.');
    const logo = selection(root).dataset.kind === 'logo';
    if (!logo && ['loading','error'].includes(root.dataset.fontLibrary)) throw Error('Lettering fonts are not ready. Please wait or reload before adding engraving.');
    const company = $(root, '[data-eng-company]').value.trim();
    const file = $(root, '[data-eng-file]').files[0];
    const target = $(root, '[data-eng-target]')?.value.trim();
    if (isStandalone(root) && !target) throw Error('Enter the product name or existing order number for this engraving.');
    if (!logo && !company) throw Error('Enter the company name exactly as you want it engraved.');
    if (company.length > 80) throw Error('Company name must be 80 characters or fewer.');
    if (logo) {
      if (!window.stEngravingFiles) throw Error('Artwork support is still loading. Refresh and try again.');
      await window.stEngravingFiles.validate(file);
    }
    const consent = $(root, '[data-eng-consent]');
    if (!consent.checked || consent.dataset.approved !== 'true') throw Error('Confirm the text/artwork and single-color black or paint-burn finish before adding engraving.');
    const font = $(root, '[data-eng-font]')?.value || 'sans';
    return {logo, company, file, target, font, fontLabel: window.stEngravingPackages.fontLabel(font)};
  }
  async function addWithEngraving(root) {
    if (root.dataset.busy === 'true') return;
    const form = root.closest('form');
    const status = $(root, '[data-eng-status]');
    const controls = [...form.querySelectorAll('input, select, textarea, button')];
    let locked = [];
    message(root, '');
    try {
      root.dataset.busy = 'true';
      // Snapshot before disabling controls, then keep artwork/variant/size stable
      // while image loading and both preview exports complete.
      const existing = new FormData(form);
      const hasEngraving = selected(root);
      const pin = pinSelected(root) ? pinSelection(root) : null;
      if (pin?.disabled) throw Error('This pin upgrade is currently unavailable.');
      locked = controls.map(control => [control, control.disabled]);
      controls.forEach(control => { control.disabled = true; });
      const info = hasEngraving ? await validate(root) : null;
      // Layout preview must be finished (not loading/error/blank) before any cart request.
      if (hasEngraving && !window.stEngravingPreview?.export) throw Error('The engraving preview is still loading. Wait a moment and try again.');
      const preview = hasEngraving ? await window.stEngravingPreview.export(root) : null;
      const productId = String(existing.get('id') || '');
      const qty = Number(existing.get('quantity') || 1);
      if (!productId || !Number.isSafeInteger(qty) || qty < 1) throw Error('Select an available product option and a valid quantity.');
      status.textContent = info?.logo ? 'Uploading your artwork and adding selected options…' : 'Adding your item and selected options…';
      const ref = `ENG-${crypto.randomUUID()}`;
      const standalone = isStandalone(root);
      const option = selection(root);
      const pkg = hasEngraving ? window.stEngravingPackages.selected(root) : null;
      if (hasEngraving && (!pkg || option.dataset.sku !== `ENGRAVE-PKG-${pkg.kind.toUpperCase()}-${pkg.code}`)) {
        throw Error('The engraving package changed or is unavailable. Choose a package again.');
      }
      const data = new FormData();
      const accessoryIndex = standalone ? 0 : 1;
      if (!standalone) {
        data.append('items[0][id]', productId);
        data.append('items[0][quantity]', String(qty));
        for (const [key, value] of existing) {
          if (key.startsWith('properties[')) data.append(`items[0][${key.replace('[', '][')}`, value);
        }
        if (existing.get('selling_plan')) data.append('items[0][selling_plan]', existing.get('selling_plan'));
        if (hasEngraving) {
        data.append('items[0][properties][Engraving reference]', ref);
        data.append('items[0][properties][Engraving]', 'See the separately charged engraving accessory with this reference.');
        // Shopify's native nested-line relationship also links the service at checkout.
        data.append(`items[${accessoryIndex}][parent_id]`, productId);
        }
      }
      let artworkProperty;
      if (hasEngraving) {
      const prefix = `items[${accessoryIndex}]`;
      data.append(`${prefix}[id]`, option.value);
      data.append(`${prefix}[quantity]`, String(qty));
      if (!window.stEngravingJobSheet?.create) throw Error('The engraving job sheet is still loading. Wait a moment and try again.');
      const notes = $(root, '[data-eng-note]').value.trim();
      status.textContent = 'Preparing your engraving instructions and printable job sheet…';
      const jobSheet = await window.stEngravingJobSheet.create({
        preview, reference: ref, product: standalone ? info.target : root.dataset.productTitle,
        variantId: standalone ? 'Standalone engraving service' : productId,
        company: info.company, logo: info.logo, originalName: info.file?.name || '',
        notes, sides: pkg.total, fontLabel: info.logo ? '' : info.fontLabel,
        price: fmt(root, Number(option.dataset.price))
      });
      data.append(`${prefix}[properties][Print engraving job sheet]`, jobSheet, jobSheet.name);
      const properties = {
        'Engrave on': standalone ? info.target : root.dataset.productTitle,
        ...(info.logo ? {'Artwork': 'Customer logo — use the attached original file'} : {'Company name': info.company, 'Lettering font': info.fontLabel}),
        'Engraving package': `${pkg.name} (${pkg.kind === 'logo' ? 'logo' : 'company text'}) — ${fmt(root, Number(option.dataset.price))} per tool`,
        'Marks per tool': `${pkg.total} total${pkg.wheel ? `; ${pkg.per} per wheel face on ${pkg.wheel === 2 ? 'front and back faces' : 'front face only'}` : ''}${pkg.frame ? `; ${pkg.frame} on one frame side` : ''}`,
        'Engraving locations': preview.locations?.label,
        'Engraving size': preview.size,
        'Finish': 'Single-color black laser mark or paint-burn; no full-color printing',
        'Returns & warranty': 'Laser-engraved items cannot be returned or exchanged. They remain covered under warranty, and warranty replacements will include new engraving.',
        'Placement notes': notes,
        'Artwork approval': 'Customer confirmed exact text/artwork, finish, and the engraving returns and warranty policy',
        'Engraving reference': ref,
        // One compact private marker replaces the six separate internal fields.
        // checkCart expands this and continues to support existing legacy carts.
        // v5 adds package code and marks per face; v4 legacy carts remain valid.
        '_st_engraving': ['v5', standalone ? 'standalone' : 'linked', info.logo ? 'logo' : 'text',
          preview.sheaveSize || '', pkg.wheel, pkg.frame, pkg.code, pkg.wheel ? pkg.per : 0].join(':')
      };
      for (const [key, value] of Object.entries(properties)) if (value) data.append(`${prefix}[properties][${key}]`, value);
      artworkProperty = info.logo && /\.pdf$/i.test(info.file.name) ? 'Logo PDF' : 'Logo artwork';
      if (info.logo) data.append(`${prefix}[properties][${artworkProperty}]`, info.file, info.file.name);
      data.append(`${prefix}[properties][Engraving preview]`, preview.file, preview.file.name);
      if (preview.mockup) {
        data.append(`${prefix}[properties][Placement preview]`, preview.mockup.file, preview.mockup.file.name);
      }
      if (preview.diagram) {
        data.append(`${prefix}[properties][Package placement diagram]`, preview.diagram, preview.diagram.name);
      }
      if (preview.frameMockup) {
        data.append(`${prefix}[properties][Frame placement preview]`, preview.frameMockup.file, preview.frameMockup.file.name);
      }
      if (preview.sheaveSize) {
        data.append(`${prefix}[properties][Sheave size]`, preview.sheaveSize.startsWith('feed-')
          ? `${preview.sheaveSize.slice(5)} inch feeding sheave` : `${preview.sheaveSize} inch hook sheave`);
        data.append(`${prefix}[properties][Extra handling]`, '1–2 extra handling days per sheave, in addition to normal processing and shipping');
      }
      }
      if (pin) {
        const pinPrefix = `items[${hasEngraving ? 2 : 1}]`;
        data.append(`${pinPrefix}[id]`, pin.dataset.variant);
        data.append(`${pinPrefix}[quantity]`, String(qty));
        data.append(`${pinPrefix}[parent_id]`, productId);
        data.append(`${pinPrefix}[properties][Pin upgrade for]`, root.dataset.productTitle);
        data.append(`${pinPrefix}[properties][Selected tool variant]`, productId);
      }
      // One multipart request adds both lines; Shopify hosts the original as an order property.
      const response = await fetch(`${base}cart/add.js`, {method: 'POST', body: data, headers: {Accept: 'application/json'}});
      const raw = await response.text();
      let result;
      try { result = JSON.parse(raw); }
      catch {
        throw Error(response.status === 429
          ? 'Shopify is temporarily limiting cart requests. Wait a moment, then check your cart before trying again.'
          : `Shopify returned an unreadable cart response (HTTP ${response.status}). Check your cart before retrying to avoid adding duplicates.`);
      }
      if (!response.ok || result.status) throw Error(result.description || result.message || 'Shopify could not add this engraving. Please check your cart before retrying.');
      if (hasEngraving) {
      const service = result.items?.find(item => String(item.variant_id || item.id) === option.value);
      if (!service || (info.logo && !/^https:\/\//.test(service.properties?.[artworkProperty] || '')) ||
          !/^https:\/\//.test(service.properties?.['Print engraving job sheet'] || '') ||
          !/^https:\/\//.test(service.properties?.['Engraving preview'] || '') ||
           (preview.mockup && !/^https:\/\//.test(service.properties?.['Placement preview'] || '')) ||
           (preview.diagram && !/^https:\/\//.test(service.properties?.['Package placement diagram'] || service.properties?.['Package diagram'] || '')) ||
           (preview.frameMockup && !/^https:\/\//.test(service.properties?.['Frame placement preview'] || ''))) {
        throw Error('The engraving could not be verified. Check your cart before retrying; do not check out without the correct engraving details.');
      }
      }
      if (pin && !result.items?.some(item => String(item.variant_id || item.id) === pin.dataset.variant && item.quantity >= qty)) {
        throw Error('The pin upgrade could not be verified. Check your cart before retrying.');
      }
      if (hasEngraving) window.stAddonUsage?.track(root, 'addon_added_to_cart', {addon: 'engraving', quantity: qty});
      if (pin) window.stAddonUsage?.track(root, 'addon_added_to_cart', {addon: 'pins', quantity: qty});
      status.textContent = 'Added. Opening your cart to review your selected options…';
      window.location.assign(`${base}cart`);
    } catch (error) {
      status.textContent = '';
      message(root, error.message || 'Could not add engraving. Check your cart before trying again.');
    } finally {
      root.dataset.busy = 'false';
      locked.forEach(([button, disabled]) => { button.disabled = disabled; });
    }
  }
  function handleSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    let root = $(form, '[data-st-engraving]');
    if (!root) {
      const variant = $(form, '[name="id"]')?.value;
      root = [...document.querySelectorAll('[data-st-engraving]')].find(candidate =>
        configured(candidate) && $(candidate.closest('form'), '[name="id"]')?.value === variant);
    }
    // Standalone engraving can never be added bare, without a package and customization.
    if (root && isStandalone(root) && !selected(root) && form.contains(root)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      message(root, 'Choose an available engraving package and complete your engraving details first.');
      return;
    }
    if (!root || !configured(root)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addWithEngraving(root);
  }
  // Run before the theme's jQuery AJAX handler to avoid a second, unengraved add.
  window.addEventListener('submit', handleSubmit, true);
  // This theme handles add-button clicks directly, without a native submit.
  window.addEventListener('click', event => {
    const sticky = event.target.closest?.('[data-sticky-addtocart] [data-action-atc]');
    if (sticky) {
      const root = [...document.querySelectorAll('[data-st-engraving]')].find(candidate =>
        configured(candidate) && $(candidate.closest('form'), '[name="id"]')?.value === sticky.dataset.variantId);
      if (root) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const qty = sticky.closest('[data-sticky-addtocart]').querySelector('[name="quantity"]');
        const mainQty = root.closest('form').querySelector('[name="quantity"]');
        if (qty && mainQty) { mainQty.value = qty.value; refresh(root); }
        addWithEngraving(root);
        return;
      }
    }
    const button = event.target.closest?.('[data-atc-form], button[name="add"]');
    if (!button?.form) return;
    handleSubmit({
      target: button.form,
      preventDefault: () => event.preventDefault(),
      stopImmediatePropagation: () => event.stopImmediatePropagation()
    });
  }, true);

  // A quick-add from a collection can add the service without customization.
  // Prevent checkout of incomplete services and mismatched tool/service quantities.
  async function checkCart() {
    if (window.stCartGiftsValidate) await window.stCartGiftsValidate();
    const response = await fetch(`${base}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw Error('Could not verify engraving details. Please refresh the cart and try again.');
    const cart = await response.json();
    const services = cart.items.filter(item => item.handle === serviceHandle);
    for (const service of services) {
      const p = {...service.properties};
      if (p._st_engraving?.startsWith('v5:')) {
        const parts = p._st_engraving.split(':');
        const PK = {SINGLE: [1, 0, 1], TRIPLE: [1, 0, 3], BOTH: [2, 0, 1], 'TRIPLE-BOTH': [2, 0, 3], 'FRAME-BOTH': [2, 1, 1], FRAME: [0, 1, 0]};
        // Hook sheaves may use any package including FRAME; feeding sheaves are FRAME only.
        const spec = PK[parts[6]];
        const feeding = String(parts[3] || '').startsWith('feed-');
        if (parts.length !== 8 || !['linked', 'standalone'].includes(parts[1]) || !['text', 'logo'].includes(parts[2]) || !spec ||
            parts[4] !== String(spec[0]) || parts[5] !== String(spec[1]) || parts[7] !== String(spec[2]) ||
            service.sku !== `ENGRAVE-PKG-${parts[2].toUpperCase()}-${parts[6]}` ||
            (feeding ? parts[6] !== 'FRAME' : !parts[3]) ||
            !/^https:\/\//.test(p['Print engraving job sheet'] || '') || !/^https:\/\//.test(p['Package placement diagram'] || p['Package diagram'] || '')) {
          throw Error('Your engraving package details are missing or do not match. Remove this engraving and configure it again before checkout.');
        }
        [, p._st_engraving_mode, p._st_engraving_kind, p._st_sheave, p._st_wheel_sides, p._st_frame_sides] = parts;
      } else if (p._st_engraving?.startsWith('v4:')) {
        const parts = p._st_engraving.split(':');
        if (parts.length !== 6 || !['linked', 'standalone'].includes(parts[1]) ||
            !['text', 'logo'].includes(parts[2]) || !['0', '1', '2'].includes(parts[4]) ||
            !['0', '1'].includes(parts[5]) || !/^https:\/\//.test(p['Print engraving job sheet'] || '')) {
          throw Error('Your engraving job sheet is missing or incomplete. Remove this engraving and configure it again before checkout.');
        }
        [, p._st_engraving_mode, p._st_engraving_kind, p._st_sheave, p._st_wheel_sides, p._st_frame_sides] = parts;
      }
      if (p._st_sheave?.startsWith('feed-') && !p._st_engraving?.startsWith('v5:') &&
          (p._st_frame_sides !== '1' || p._st_wheel_sides !== '0' ||
           !['ENGRAVE-TEXT-1', 'ENGRAVE-LOGO-1'].includes(service.sku))) {
        throw Error('Feeding sheaves allow one frame side only. Remove this engraving and configure it again from the feeding sheave product page.');
      }
      if (!p['Engrave on'] || !p['Artwork approval'] || !p._st_engraving ||
          (p._st_sheave && p._st_wheel_sides !== '0' && !/^https:\/\//.test(p['Placement preview'] || '')) ||
          (p._st_frame_sides === '1' && !/^https:\/\//.test(p['Frame placement preview'] || '')) ||
          (p._st_engraving_kind === 'logo' ? !/^https:\/\//.test(p['Logo artwork'] || p['Logo PDF'] || '') : !p['Company name'])) {
        throw Error('Your engraving accessory needs customization. Remove it from the cart, then open the engraving product page to enter your company name or upload your artwork.');
      }
      if (p._st_engraving_mode === 'linked') {
        const parent = cart.items.find(item => item.handle !== serviceHandle &&
          item.properties?.['Engraving reference'] === p['Engraving reference']);
        if (!parent) throw Error('An engraving accessory has no matching tool. Remove it or add engraving again from the tool’s product page.');
        if (parent.quantity !== service.quantity) throw Error('The engraving quantity must match its tool quantity. Adjust the quantities in your cart before checkout.');
      }
    }
    return cart;
  }
  let checkoutBusy = false;
  let replayCheckout = false;
  window.addEventListener('click', async event => {
    if (replayCheckout) return;
    const trigger = event.target.closest?.('[name="checkout"], a[href$="/checkout"], [data-st-checkout]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      await checkCart();
      // Preserve the theme's terms checkbox, member discounts and checkout handlers.
      replayCheckout = true;
      try { trigger.click(); } finally { replayCheckout = false; }
    } catch (error) {
      showCartError(error.message);
    } finally { checkoutBusy = false; }
  }, true);
  window.addEventListener('submit', async event => {
    if (replayCheckout) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/?$/.test(new URL(form.action).pathname) ||
      event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      await checkCart();
      replayCheckout = true;
      try { form.requestSubmit(event.submitter); } finally { replayCheckout = false; }
    }
    catch (error) { showCartError(error.message); }
    finally { checkoutBusy = false; }
  }, true);
  function showCartError(text) {
    let el = document.getElementById('st-engraving-cart-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'st-engraving-cart-error';
      el.setAttribute('role', 'alert');
      const close = document.createElement('button');
      close.type = 'button'; close.textContent = 'Close'; close.onclick = () => el.remove();
      const body = document.createElement('p');
      body.dataset.message = '';
      const link = document.createElement('a');
      link.href = `${base}products/${serviceHandle}`;
      link.textContent = 'Open engraving accessory';
      el.append(body, link, close);
      document.body.append(el);
    }
    el.querySelector('[data-message]').textContent = text;
  }
  initialize();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; initialize(); });
  }).observe(document.documentElement, {childList: true, subtree: true});
})();